export default "__VITE_ASSET__z7Hu_qqB__"